export const LINK_TYPE = {
  LINK: 'Link',
  TELEFON_PRIVAT: 'Private Telefonnummer',
  TELEFON_ARBEIT: 'Geschäftliche Telefonnummer',
  TELEFON: 'Telefon',
  EMAIL_PRIVAT: 'Private E-Mail',
  EMAIL_ARBEIT: 'Geschäftliche E-Mail',
  EMAIL: 'Email',
  GEBURTSTAG: 'Geburtstag',
  NOTIZEN: 'Notizen',
  ADRESSE: 'Adresse',
  ADRESSE_PRIVAT: 'Privatadresse',
  ADRESSE_FIRMA: 'Firmenadresse',
  SOCIAL_MEDIA: 'Social Media',
};

export const USER_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  BLOCKED: 'blocked',
};

export const CARD_STATUS = {
  ORDERED: 'ordered',
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  DEMO: 'demo',
  UNCLAIMED: 'unclaimed',
};

export const ORDER_STATUS = {
  AUSSTEHEND: 'Ausstehend',
  FEHLGESCHLAGEN: 'Fehlgeschlagen',
  BEZAHLT: 'Bezahlt',
  GELIEFERT: 'Geliefert',
  ABGEBROCHEN: 'Abgebrochen',
};
